module.exports = __webpack_public_path__ + "img/wait-next-stage.25439afa.png";